import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';
import ModalConfirm from '../../../../../ModalConfirm';

interface DialogState {
	isOpen?: boolean;
	open: () => void;
	close: () => void;
}

interface Props {
	text: string;
	acceptText: string;
	cancelText?: string;
	onAccept: () => void | Promise<any>;
	onCancel?: () => void;
	children?: (state: DialogState) => React.ReactNode;
	open?: boolean;
	iconClassName?: string;
	icon?: React.ReactNode;
}

const successIcon = (
	<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="18" cy="18" r="18" fill="#5FCA43" />
		<path d="M11.1738 18.5147L15.5796 23.25L25.3488 12.75" stroke="white" strokeWidth="2.1" strokeLinecap="round" />
	</svg>
);

const Dialog: React.FC<Props> = props => {
	const [isOpen, setOpen] = React.useState(props.open);
	const [isLoading, setLoading] = React.useState(false);

	const open = () => setOpen(true);
	const close = () => setOpen(false);

	const onAccept = () => {
		const accept = props.onAccept();

		if (typeof accept === 'object' && typeof accept['then'] === 'function') {
			setLoading(true);

			(accept as Promise<any>).then(close);
		} else {
			close();
		}
	};

	const onCancel = () => {
		props.onCancel();

		close();
	};

	const theme = useTheme('Exchange').Dialog;

	return (
		<>
			{props.children &&
				props.children({
					open,
					close,
					isOpen
				})}

			<ModalConfirm
				size="small"
				isOpen={isOpen}
				onCancel={props.cancelText ? onCancel : null}
				isLoading={isLoading}
				cancelBtn={props.cancelText}
				onClose={close}
				confirmBtn={props.acceptText}
				onConfirm={onAccept}
			>
				<div className={theme.content}>
					<div className={cn(theme.icon, props.iconClassName)}>{successIcon}</div>
					<div>{props.text}</div>
				</div>
			</ModalConfirm>
		</>
	);
};

export default Dialog;
